module.exports = __webpack_public_path__ + "static/media/resource-4@2x.4d509869.jpg";